import { render, staticRenderFns } from "./PayFort.vue?vue&type=template&id=5491c72a&scoped=true&"
import script from "./PayFort.vue?vue&type=script&lang=js&"
export * from "./PayFort.vue?vue&type=script&lang=js&"
import style0 from "./PayFort.vue?vue&type=style&index=0&id=5491c72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491c72a",
  null
  
)

export default component.exports